<template>
    <div>
        <span class="link" v-on:click="showModal();">Modtag elev-id</span>

        <modal name="resetPassword" :height="'auto'">
            <div class="modal-header">
                <h5 class="mb-0">Modtag elev-id</h5>
            </div>
            <div class="modal-body">
                <p>Hvis du ikke har modtaget et elev-id, kan du skrive din e-mail i feltet nedenfor - Så sender dig vi et nyt.</p>
                <form v-on:submit.prevent="resetPassword();">
                    <div class="form-group">
                        <input 
                        type="email" 
                        class="form-control" 
                        placeholder="Indtast e-mail adresse" 
                        v-model="formPayload.email"
                        required>
                        <div class="help-text mt-2" v-if="formResponse">
                            <p class="mb-0 mt-1 text-danger" v-if="formResponse.type == 'error'">{{ formResponse.text }}</p>
                            <p class="mb-0 mt-1 text-success" v-if="formResponse.type == 'success'">{{ formResponse.text }}</p>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" @click="hideModal();">Annullér</button>
                <button type="submit" class="btn btn-primary" @click="handleSubmit();">
                    <span v-if="isLoading"><div class="loader mx-auto"></div></span>
                    <span v-else>Modtag elev-id</span>
                </button>
            </div>
        </modal>
    </div>
</template>


<script>
export default {
    data: function() {
        return {
            formPayload: {
                email: '',
            },

            formResponse: {
                type: '',
                text: '',
            },

            isLoading: false,
        }
    },

    methods: {
        resetPassword() {
            this.isLoading = true;

            this.axios.post('auth/reset/password', this.formPayload)
                .then(res => {
                    this.$modal.hide('resetPassword');

                    this.$notify({
                        group: 'main',
                        type: 'success',
                        title: 'Vi har sendt dig en e-mail!',
                        text: 'Tjek venligst din indboks for at komme igang',
                        duration: 7500,
                    });

                    this.isLoading = false;
                })
                .catch(error => {
                    this.isLoading = false;
                    this.formResponse.type = 'error';
                    this.formResponse.text = error.response.data.message;
                    if(error.response.status = 404) {
                        this.formResponse.text = 'Denne e-mail er ikke registeret til en elev.';
                    }
                });
        },

        handleSubmit() {
            this.resetPassword();
        },

        showModal() {
            this.$modal.show('resetPassword');
        },
        hideModal() {
            this.$modal.hide('resetPassword');
        },
    }
}
</script>
